import React from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';
import {BioentityChip} from 'ui-library/chips/BioentityChip';
import {ChipSize} from 'ui-library/chips/Chip';

type PolymerTitleProps =
  | {polymerId: string; polymerName?: string}
  | {polymerId: string | null; polymerName: string};

export function PolymerTitle({polymerId, polymerName}: PolymerTitleProps): JSX.Element {
  return (
    <div {...getTestProps({component: 'PolymerTitle', element: 'root'})}>
      {polymerId != null ? (
        <BioentityChip id={polymerId} size={ChipSize.MINI} validationExtras={null} />
      ) : (
        <span>{polymerName}</span>
      )}
    </div>
  );
}
